export default defineNuxtRouteMiddleware(() => {
  const accessStore = useAccessStore();
  accessStore.setPartialAccessDenied(false);
});
